export default __webpack_public_path__ + "static/media/Tigerstrike.344e7342.jpg";